import { formatDollarsByRange } from './formatDollarsByRange';

const ranges: FormatDollarsRange[] = [
    {
        max: 1000000,
        style: 'standard',
        precision: 2,
    },
    {
        max: Infinity,
        style: 'compact',
        precision: 1,
    },
];

/**
 * Formats a dollar amount according to a specific set of rules:
 * 1. For values up to 1 million, rounds to 2 decimal places of precision and pads zeroes up to two
 * decimal places
 *      Example: 2333.332 => '$2,333.33'
 *      Example: 566.9 => '$566.90'
 * 3. For values over 1 million, uses roman numeral notation with one decimal place of precision, i.e.
 * '$1.1K'
 *      Example: 1200000.12 => '$1.2M'
 * @param {number} value a dollar amount
 */
export const formatDollarsKpi = (value: number): string =>
    formatDollarsByRange({ value, ranges });
